import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';

/**
 * AccordionShowcase Component
 * Displays accordion component with theme styling
 */
const AccordionShowcase = ({ theme }) => {
  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Typography variant="subtitle2" gutterBottom>
        Accordion
      </Typography>
      <Accordion sx={{ backgroundColor: theme.surface_color }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: theme.primary_color }} />}
          sx={{ color: theme.text_color }}
        >
          <Typography sx={{ fontFamily: theme.font_family }}>
            Expandable Section
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            sx={{
              color: theme.text_color,
              fontFamily: theme.font_family,
              fontSize: theme.font_size,
            }}
          >
            Content inside the accordion with theme styling applied.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

AccordionShowcase.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default AccordionShowcase;
